/**
 * ============================================================
 * KEJJA OS — src/lib/firebase.ts (frontend)
 * Firebase Web SDK initialization.
 * ============================================================
 *
 * Uses config from VITE_FIREBASE_* env vars (public, safe to expose).
 * Initializes once, exports `firebaseAuth` for sign-in flows.
 * ============================================================
 */

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validate at load time — fail fast if env is missing
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain) {
  throw new Error(
    'Firebase env vars missing. Check VITE_FIREBASE_* in .env.local.',
  );
}

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

// Persist sign-in across browser reloads (uses IndexedDB)
setPersistence(firebaseAuth, browserLocalPersistence).catch((err) => {
  console.warn('Firebase persistence setup failed:', err);
});

// Preconfigured Google provider (we'll use this in the login page)
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',  // always let user pick an account
});

